// Static mock data for the White Card VIC training website

export const COMPANY = {
  name: "White Card VIC",
  tagline: "Same Day Certification | Nationally Accredited",
  legal: "RTO Provider #45698",
  phone: "(03) 5941 5070",
  email: "wc@git.vic.edu.au",
  abn: "43 639 844 992",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "White Card Course", to: "/course" },
  { label: "Course Calendar", to: "/calendar" },
  { label: "Locations", to: "/locations" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const HERO = {
  eyebrow: "CPCWHS1001 - Prepare to work safely in the construction industry",
  title: "White Card VIC",
  subtitle: "Book Your Course. Get Certified. Same-Day Processing.",
  bullets: [
    "Nationally recognised construction induction card",
    "Face-to-face training across Melbourne",
    "Certificate issued the same day",
  ],
  heroImage: "/photos/hero-main-2.jpg",
  sideImage: "https://images.pexels.com/photos/7983565/pexels-photo-7983565.jpeg",
};

export const WHY_US = [
  { icon: "ShieldCheck", title: "Nationally Accredited RTO", body: "Registered Training Organisation delivering CPCWHS1001 - recognised across Australia." },
  { icon: "Clock", title: "Same-Day Certification", body: "Complete your training and walk out with your Statement of Attainment the same day." },
  { icon: "MapPin", title: "2 Melbourne Locations", body: "CBD, St Kilda and West Melbourne - with public transport nearby." },
  { icon: "Users", title: "Expert Trainers", body: "Trainers with 15+ years experience on real Australian construction sites." },
  { icon: "BadgeCheck", title: "WorkSafe VIC Approved", body: "Fully compliant with WorkSafe Victoria requirements for construction white cards." },
  { icon: "DollarSign", title: "Best Price Guarantee", body: "$130 - the most competitive full-course rate in Victoria." },
];

export const BENEFITS = [
  "Work legally on any Australian construction site",
  "Nationally recognised and never expires",
  "Required by all major builders and subcontractors",
  "Improve site safety awareness and reduce workplace incidents",
  "First step toward higher construction qualifications",
  "Recognised by WorkSafe Victoria and equivalent state bodies",
];

export const REVIEWS = [
  { name: "Daniel R.", role: "Carpenter, Southbank", rating: 5, text: "Trainer was excellent - plain-English explanations, real site examples. Had my card in my hand before lunch. Highly recommend.", avatar: "https://i.pravatar.cc/120?img=12" },
  { name: "Aisha K.", role: "Site Labourer, Docklands", rating: 5, text: "Booked online Sunday night, sat the course Monday morning. The West Melbourne centre was easy to find and staff were super helpful.", avatar: "https://i.pravatar.cc/120?img=32" },
  { name: "Marcus T.", role: "Apprentice Electrician", rating: 5, text: "Great value for $130. Content was engaging and I didn't feel rushed. Certificate emailed within an hour.", avatar: "https://i.pravatar.cc/120?img=54" },
  { name: "Priya S.", role: "Project Coordinator", rating: 4, text: "Enrolled 8 of my crew - group booking process was smooth. Would use again for future compliance training.", avatar: "https://i.pravatar.cc/120?img=45" },
];

export const FAQ_ITEMS = [
  { q: "What is a White Card?", a: "A White Card (also known as a Construction Induction Card) is a nationally recognised certification that shows you have completed the required WHS training to work on Australian construction sites. It is the CPCWHS1001 unit of competency." },
  { q: "How long does the course take?", a: "The face-to-face course runs for one full day (approximately 6 hours) including a short lunch break. You will receive your Statement of Attainment on the same day." },
  { q: "How much does it cost?", a: "The full-course fee is $130 AUD including GST. This covers all training materials, assessment, and issuing of your certificate and physical card." },
  { q: "Do I need a Unique Student Identifier (USI)?", a: "Yes. As per the Australian Government requirement, all students must have a USI before we can issue a Statement of Attainment. You can create one for free at usi.gov.au - we can also help you during enrolment." },
  { q: "What identification do I need to bring?", a: "You must bring one form of photo ID (Australian driver licence, passport, or proof-of-age card). International students must bring their passport plus an Australian address document." },
  { q: "Does the White Card expire?", a: "The Victorian White Card does not have an expiry date. However, if you do not work in construction for 2 or more consecutive years, you must complete the course again." },
  { q: "Can I do the course online?", a: "We currently deliver face-to-face training only, as this is the format most trusted by builders and WorkSafe Victoria. This ensures you meet all state compliance requirements." },
  { q: "What if I fail the assessment?", a: "Our trainers will support you throughout the day. If you are not competent by the end of the session, you can re-sit the assessment free of charge within 30 days." },
];

export const COURSE = {
  code: "CPCWHS1001",
  name: "Prepare to work safely in the construction industry",
  duration: "1 Day (6 hours face-to-face)",
  location: "Melbourne CBD, St Kilda, West Melbourne",
  fee: 95,
  gstIncluded: true,
  requirements: [
    "Minimum 14 years of age",
    "Valid photo ID (driver licence, passport, proof-of-age)",
    "Unique Student Identifier (USI)",
    "Basic English language ability",
  ],
  outcomes: [
    "Identify workplace hazards and control risks",
    "Understand roles and responsibilities under WHS legislation",
    "Follow safe work practices and procedures on site",
    "Correctly use personal protective equipment (PPE)",
    "Respond to workplace incidents and emergencies",
    "Communicate effectively about safety on site",
  ],
  assessment: [
    "Multiple-choice written knowledge test",
    "Practical scenario-based questions",
    "Verbal Q&A with trainer",
  ],
};

export const LOCATIONS = [
  {
    id: "head-office",
    name: "Head Office",
    address: "4/70 Main Street, Pakenham VIC, 3810",
    phone: "+61 3 5941 5070",
    hours: "Mon-Fri, 8:30am - 5:00pm",
    map: "https://www.google.com/maps?q=4/70+Main+Street,+Pakenham+VIC+3810&output=embed",
    image: "https://images.pexels.com/photos/8436835/pexels-photo-8436835.jpeg",
    courses: [
      "White Card (CPCWHS1001)",
      "Working at Heights",
      "First Aid"
    ],
    transit: "Approx. 10 min walk from Pakenham Railway Station",
  },
  {
    id: "north-melbourne",
    name: "North Melbourne Campus",
    address: "15-17 Racecourse Rd, North Melbourne VIC, 3051",
    phone: "+61 3 5941 5070",
    hours: "Mon-Fri, 8:30am - 5:00pm",
    map: "https://www.google.com/maps?q=15-17+Racecourse+Rd,+North+Melbourne+VIC+3051&output=embed",
    image: "https://images.pexels.com/photos/280221/pexels-photo-280221.jpeg",
    courses: [
      "White Card (CPCWHS1001)",
      "Manual Handling"
    ],
    transit: "Easy access via North Melbourne public transport",
  },
];

// Generate 12 upcoming classes across locations
const _today = new Date();
const _addDays = (d) => { const x = new Date(_today); x.setDate(_today.getDate() + d); return x; };
const _fmt = (d) => d.toISOString().split('T')[0];

export const UPCOMING_CLASSES = [
  { id: "C-1001", date: _fmt(_addDays(1)), day: "Tomorrow", time: "8:30 AM - 3:30 PM", location: "Melbourne CBD", locationId: "cbd", seats: 4, capacity: 20, trainer: "James O'Connor", price: 135 },
  { id: "C-1002", date: _fmt(_addDays(2)), day: "Thu", time: "8:30 AM - 3:30 PM", location: "St Kilda", locationId: "st-kilda", seats: 11, capacity: 18, trainer: "Sarah Nguyen", price: 135 },
  { id: "C-1003", date: _fmt(_addDays(3)), day: "Fri", time: "8:30 AM - 3:30 PM", location: "West Melbourne", locationId: "west-melbourne", seats: 2, capacity: 20, trainer: "Marco Ferrari", price: 135 },
  { id: "C-1004", date: _fmt(_addDays(4)), day: "Sat", time: "8:30 AM - 3:30 PM", location: "Melbourne CBD", locationId: "cbd", seats: 8, capacity: 20, trainer: "James O'Connor", price: 135 },
  { id: "C-1005", date: _fmt(_addDays(7)), day: "Next Tue", time: "8:30 AM - 3:30 PM", location: "Melbourne CBD", locationId: "cbd", seats: 15, capacity: 20, trainer: "Priya Reddy", price: 135 },
  { id: "C-1006", date: _fmt(_addDays(8)), day: "Next Wed", time: "8:30 AM - 3:30 PM", location: "St Kilda", locationId: "st-kilda", seats: 6, capacity: 18, trainer: "Sarah Nguyen", price: 135 },
  { id: "C-1007", date: _fmt(_addDays(9)), day: "Next Thu", time: "8:30 AM - 3:30 PM", location: "West Melbourne", locationId: "west-melbourne", seats: 12, capacity: 20, trainer: "Marco Ferrari", price: 135 },
  { id: "C-1008", date: _fmt(_addDays(10)), day: "Next Fri", time: "8:30 AM - 3:30 PM", location: "Melbourne CBD", locationId: "cbd", seats: 0, capacity: 20, trainer: "James O'Connor", price: 135 },
  { id: "C-1009", date: _fmt(_addDays(14)), day: "Tue", time: "8:30 AM - 3:30 PM", location: "St Kilda", locationId: "st-kilda", seats: 18, capacity: 18, trainer: "Priya Reddy", price: 135 },
  { id: "C-1010", date: _fmt(_addDays(15)), day: "Wed", time: "8:30 AM - 3:30 PM", location: "Melbourne CBD", locationId: "cbd", seats: 20, capacity: 20, trainer: "James O'Connor", price: 135 },
  { id: "C-1011", date: _fmt(_addDays(16)), day: "Thu", time: "8:30 AM - 3:30 PM", location: "West Melbourne", locationId: "west-melbourne", seats: 14, capacity: 20, trainer: "Marco Ferrari", price: 135 },
  { id: "C-1012", date: _fmt(_addDays(17)), day: "Fri", time: "8:30 AM - 3:30 PM", location: "Melbourne CBD", locationId: "cbd", seats: 10, capacity: 20, trainer: "Sarah Nguyen", price: 135 },
];

export const TRAINERS = [
  { id: "T-01", name: "James O'Connor", email: "james@whitecardvic.com.au", phone: "0412 345 678", qualification: "Cert IV TAE + 22 yrs construction", classes: 42, avatar: "https://i.pravatar.cc/200?img=51" },
  { id: "T-02", name: "Sarah Nguyen", email: "sarah@whitecardvic.com.au", phone: "0423 456 789", qualification: "Cert IV TAE + WHS Officer", classes: 38, avatar: "https://i.pravatar.cc/200?img=48" },
  { id: "T-03", name: "Marco Ferrari", email: "marco@whitecardvic.com.au", phone: "0434 567 890", qualification: "Cert IV TAE + Site Supervisor", classes: 51, avatar: "https://i.pravatar.cc/200?img=60" },
  { id: "T-04", name: "Priya Reddy", email: "priya@whitecardvic.com.au", phone: "0445 678 901", qualification: "Cert IV TAE + HSE Consultant", classes: 29, avatar: "https://i.pravatar.cc/200?img=47" },
];

export const ADMIN_STATS = {
  todayEnrolments: 12,
  upcomingClasses: 18,
  revenueMonth: 48250,
  revenueToday: 1620,
  totalStudents: 2847,
  activeBookings: 96,
  pendingCertificates: 4,
  completionRate: 97.4,
};

export const REVENUE_CHART = [
  { month: "Aug", revenue: 32400, students: 240 },
  { month: "Sep", revenue: 38900, students: 288 },
  { month: "Oct", revenue: 41200, students: 305 },
  { month: "Nov", revenue: 45800, students: 339 },
  { month: "Dec", revenue: 39600, students: 293 },
  { month: "Jan", revenue: 48250, students: 358 },
];

export const STUDENTS = [
  { id: "S-10023", name: "Daniel Roberts", email: "daniel.r@example.com", phone: "0412 111 222", status: "Active", enrolments: 1, joined: "2026-01-15", usiNumber: "A5C7X9B2K1" },
  { id: "S-10024", name: "Aisha Khan", email: "aisha.k@example.com", phone: "0423 222 333", status: "Active", enrolments: 2, joined: "2026-01-16", usiNumber: "B6D8Y1C3L2" },
  { id: "S-10025", name: "Marcus Thompson", email: "marcus.t@example.com", phone: "0434 333 444", status: "Completed", enrolments: 1, joined: "2026-01-18", usiNumber: "C7E9Z2D4M3" },
  { id: "S-10026", name: "Priya Sharma", email: "priya.s@example.com", phone: "0445 444 555", status: "Active", enrolments: 1, joined: "2026-01-20", usiNumber: "D8F1A3E5N4" },
  { id: "S-10027", name: "Liam O'Brien", email: "liam.o@example.com", phone: "0456 555 666", status: "Suspended", enrolments: 0, joined: "2026-01-22", usiNumber: "E9G2B4F6O5" },
  { id: "S-10028", name: "Chloe Anderson", email: "chloe.a@example.com", phone: "0467 666 777", status: "Active", enrolments: 1, joined: "2026-01-25", usiNumber: "F1H3C5G7P6" },
  { id: "S-10029", name: "Noah Wilson", email: "noah.w@example.com", phone: "0478 777 888", status: "Active", enrolments: 1, joined: "2026-01-28", usiNumber: "G2I4D6H8Q7" },
  { id: "S-10030", name: "Zara Ahmed", email: "zara.a@example.com", phone: "0489 888 999", status: "Completed", enrolments: 1, joined: "2026-02-01", usiNumber: "H3J5E7I9R8" },
];

export const ENROLMENTS = [
  { id: "E-2001", student: "Daniel Roberts", course: "CPCWHS1001", class: "C-1001", status: "Approved", amount: 135, date: "2026-02-10" },
  { id: "E-2002", student: "Aisha Khan", course: "CPCWHS1001", class: "C-1002", status: "Pending", amount: 135, date: "2026-02-10" },
  { id: "E-2003", student: "Marcus Thompson", course: "CPCWHS1001", class: "C-1005", status: "Completed", amount: 135, date: "2026-02-09" },
  { id: "E-2004", student: "Priya Sharma", course: "CPCWHS1001", class: "C-1003", status: "Approved", amount: 135, date: "2026-02-09" },
  { id: "E-2005", student: "Chloe Anderson", course: "CPCWHS1001", class: "C-1004", status: "Approved", amount: 135, date: "2026-02-08" },
  { id: "E-2006", student: "Noah Wilson", course: "CPCWHS1001", class: "C-1006", status: "Pending", amount: 135, date: "2026-02-08" },
  { id: "E-2007", student: "Zara Ahmed", course: "CPCWHS1001", class: "C-1008", status: "Completed", amount: 135, date: "2026-02-05" },
  { id: "E-2008", student: "Liam O'Brien", course: "CPCWHS1001", class: "C-1002", status: "Cancelled", amount: 135, date: "2026-02-04" },
];

export const PAYMENTS = [
  { id: "P-3001", student: "Daniel Roberts", amount: 135, method: "Visa •••• 4242", status: "Paid", date: "2026-02-10", receipt: "R-3001" },
  { id: "P-3002", student: "Aisha Khan", amount: 135, method: "Mastercard •••• 5555", status: "Pending", date: "2026-02-10", receipt: null },
  { id: "P-3003", student: "Marcus Thompson", amount: 135, method: "Visa •••• 4111", status: "Paid", date: "2026-02-09", receipt: "R-3003" },
  { id: "P-3004", student: "Priya Sharma", amount: 135, method: "Amex •••• 0005", status: "Paid", date: "2026-02-09", receipt: "R-3004" },
  { id: "P-3005", student: "Chloe Anderson", amount: 135, method: "Visa •••• 8888", status: "Paid", date: "2026-02-08", receipt: "R-3005" },
  { id: "P-3006", student: "Zara Ahmed", amount: 135, method: "Mastercard •••• 3333", status: "Refunded", date: "2026-02-05", receipt: "R-3006" },
];

export const CERTIFICATES = [
  { id: "CT-4001", student: "Marcus Thompson", course: "CPCWHS1001", issued: "2026-01-25", certificateNumber: "VIC-WC-2026-0125-4001", status: "Issued" },
  { id: "CT-4002", student: "Zara Ahmed", course: "CPCWHS1001", issued: "2026-02-01", certificateNumber: "VIC-WC-2026-0201-4002", status: "Issued" },
  { id: "CT-4003", student: "Daniel Roberts", course: "CPCWHS1001", issued: "2026-02-10", certificateNumber: "VIC-WC-2026-0210-4003", status: "Issued" },
  { id: "CT-4004", student: "Chloe Anderson", course: "CPCWHS1001", issued: null, certificateNumber: null, status: "Pending" },
];

export const NOTIFICATIONS = [
  { id: "N-1", type: "success", title: "Payment received", body: "Your enrolment for 12 Feb is confirmed. Receipt R-3001.", time: "2 hours ago" },
  { id: "N-2", type: "info", title: "Reminder: Course tomorrow", body: "Melbourne CBD - 8:30 AM. Bring photo ID + USI.", time: "1 day ago" },
  { id: "N-3", type: "info", title: "USI verified", body: "Your Unique Student Identifier has been verified.", time: "3 days ago" },
  { id: "N-4", type: "success", title: "Welcome!", body: "Your account has been created successfully.", time: "5 days ago" },
];

// Mock logged-in student
export const CURRENT_STUDENT = {
  id: "S-10023",
  firstName: "Daniel",
  lastName: "Roberts",
  email: "daniel.r@example.com",
  phone: "0412 111 222",
  dob: "1995-06-14",
  gender: "Male",
  address: "42 Bourke Street, Melbourne VIC 3000",
  state: "VIC",
  country: "Australia",
  emergencyContactName: "Sarah Roberts",
  emergencyPhone: "0423 555 666",
  emergencyRelationship: "Sister",
  usiNumber: "A5C7X9B2K1",
  photo: "https://i.pravatar.cc/240?img=12",
  profileCompletion: 85,
  nextClass: { id: "C-1001", date: "2026-02-12", time: "8:30 AM", location: "Melbourne CBD" },
};

export const ATTENDANCE = [
  { classId: "C-0990", date: "2026-01-25", student: "Marcus Thompson", status: "Present" },
  { classId: "C-0991", date: "2026-01-25", student: "Aisha Khan", status: "Present" },
  { classId: "C-0991", date: "2026-01-25", student: "Liam O'Brien", status: "Absent" },
  { classId: "C-0992", date: "2026-02-01", student: "Zara Ahmed", status: "Present" },
  { classId: "C-0992", date: "2026-02-01", student: "Priya Sharma", status: "Late" },
];

export const STATUS_STYLES = {
  Active: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Completed: "bg-blue-50 text-blue-700 border border-blue-200",
  Pending: "bg-amber-50 text-amber-700 border border-amber-200",
  Approved: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Suspended: "bg-slate-100 text-slate-700 border border-slate-200",
  Cancelled: "bg-rose-50 text-rose-700 border border-rose-200",
  Rejected: "bg-rose-50 text-rose-700 border border-rose-200",
  Paid: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Refunded: "bg-slate-100 text-slate-700 border border-slate-200",
  Issued: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Present: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Absent: "bg-rose-50 text-rose-700 border border-rose-200",
  Late: "bg-amber-50 text-amber-700 border border-amber-200",
};
